import React, { useState, useEffect } from 'react';
import { Link, Router,useNavigate } from 'react-router-dom';
import { Row, Col, Container, Button, ModalHeader, ModalFooter, Modal, ModalBody } from "reactstrap";
import PageLayout from '../../layouts/PageLayout';
import { API_URL } from '../../../config';
import right from '../../images/right.png';
import "./TechSupport.css";


const TechSupport = () => {
  const [countrys, setCountrys] = useState([]);
  const [states, setStates] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [telephone, setTelephone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [address, setAddress] = useState('');
  const [address1, setAddress1] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');
  const [Loader, setLoader] = useState(false);
  const [fillallfieldmodal, setFillallfieldModal] = useState(false);
  const fillallfieldtoggleModal = () => setFillallfieldModal(!fillallfieldmodal);
  const [emailalreadyExitmodal, setEmailalreadyExitmodal] = useState(false);
  const EmailalreadyExittoggleModal = () => setEmailalreadyExitmodal(!emailalreadyExitmodal);
  const [error, setError] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);


  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
};
  
  useEffect(() => {
    getCountry();

  }, [])

  const getCountry = () => {
    fetch(API_URL + "/countries",
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setCountrys(resp.countries);

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }

  const getState = (countryid) => {



    fetch(API_URL + "/states?country_id=" + countryid,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',

        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setStates(resp.states);

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }

  const handleCountryUpdate = (e) => {
    getState(e.target.value)

    setCountry(e.target.value)

  }

  const handlestate =(e)=>{
    setState(e.target.value)
  }


  const createProfile = () => {
    setLoader(true)
    const str1 = firstName
    const capfname = str1.charAt(0).toUpperCase() + str1.slice(1);
    const str2 = lastName
    const caplname = str2.charAt(0).toUpperCase() + str2.slice(1);
    let data = {};
    data['user_type'] = 8;
    data['firstname'] = capfname;
    data['lastname'] = caplname;
    data['telephone'] = telephone;
    data['email'] = email;
    data['password'] = password;
    data['business'] = businessName;
    data['address'] = address;
    data['address2'] = address1
    data['zipcode'] = postalCode;
    data['city'] = city;
    data['state'] = state;
    data['country'] = country;


    function isValidEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    }
  
    
  
      if (!isValidEmail(email)) {
        setError(true);
        setLoader(false)
        return false;
      } else {
        setError(false);
      }
  
  


    if (firstName == "" || lastName == "" || telephone == "" || email == "" || password == "") {
      fillallfieldtoggleModal();
      setLoader(false)

      return false;
    } else {
      setLoader(true)
    }

    fetch(API_URL + "/create/distributer/profile", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',

      },
      body: JSON.stringify(data)
    }).then((response) => {
      if (response.status == 201) {
        response.json().then((resp) => {
          successToggleModal();
          setLoader(false)
          setFirstName("")
          setLastName("")
          setTelephone("")
          setEmail("")
          setPassword("")
          setAddress("")
          setAddress1("")
          setCountry("")
          setState("")
          setPostalCode("")

        });
      }
      else if (response.status == 400) {
        setLoader(false)
        EmailalreadyExittoggleModal();
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        setLoader(false)
        console.log("network error")
      }


    })

  }



  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleEmail = (e) => {

    if (!isValidEmail(e.target.value)) {
      setError(true);
    } else {
      setError(false);
    }

    setEmail(e.target.value)
  }



  const navigate = useNavigate()


  const handleGoBack = () => {
    navigate('/distributors');
  }

  const handleKeyPress = (event) => {
    // Prevent the user from typing alphabetic characters
    const key = event.key;
    // const regex = /^[0-9-.]$/;
    const regex = /^[\d().+-]+$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  };


  return (
    <PageLayout className="tech-support-container">
      <div className="tech-support-content">
        <div className="head-listing head-listingb">
                            <h3>Add Tech Support Executive</h3>
                        </div>
     
          <div className='right-section-box'>

            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>First Name* </label>
                  <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} className='client-input' placeholder='Enter first name' />
                </div>
                <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>
                    Last Name*</label>
                  <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} className='client-input' placeholder='Enter last name' /></div>
                <div className='form-group col-lg-4 no-padding'>
                  <label className='control-label'>
                    Telephone*</label>
                  <input type="text" onKeyPress={handleKeyPress} value={telephone} onChange={(e) => setTelephone(e.target.value)} className='client-input' placeholder='Enter a telephone' />
                </div>
              </div>
            </div>

            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>
                    Email*</label>
                  <input type="email" onChange={handleEmail} className='client-input' placeholder='Enter an email' />
                  {
                    error && <p className='validemail'>Invalid Email</p>
                  }
                </div>
                <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label relativeinput'>
                    Password*</label>
                  <input type={passwordShown ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className='client-input' placeholder='Enter a password' />
                  {
                    passwordShown ? <i class="fa fa-eye-slash pass-eye3" aria-hidden="true" onClick={togglePasswordVisiblity}></i> : <i className="fa fa-eye pass-eye3" aria-hidden="true" onClick={togglePasswordVisiblity}></i>
                  }
                  </div>
                {/* <div className='form-group col-lg-4 no-padding'>
                  <label className=' control-label'>
                    Business Name</label>
                  <input type="text" value={businessName} onChange={(e) => setBusinessName(e.target.value)} className='client-input' placeholder='Enter business' /></div> */}
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className='control-label'>
                    Address</label>
                  <textarea type="textarea" rows='1' cols='52' name='address' value={address} onChange={(e) => setAddress(e.target.value)} className='client-input' placeholder='Enter physical address 1' /></div>
                <div className='form-group col-lg-12 no-padding'>
                  <textarea type="textarea" rows='1' cols='52' name='address' value={address1} onChange={(e) => setAddress1(e.target.value)} className='client-input' placeholder='Enter physical address 2' /></div>
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>

                <div className='form-group col-lg-3 no-padding'>
                  <label className=' control-label'>
                    Country</label>
                  <select onChange={handleCountryUpdate}  className='client-input' placeholder='Choose Country'>
                    <option value="">Select Country</option>

                    {
                      countrys.length > 0 && countrys.map((val, i) => {
                        return (
                          <option value={val.id}>{val.name}</option>
                        )
                      })
                    }
                  </select></div>
                <div className='form-group col-lg-3 no-padding'>
                  <label className=' control-label'> State</label>
                  <select className='client-input' onChange={handlestate} placeholder='Choose States/Province'>
                    <option value="">Select State</option>

                    {
                      states.length > 0 && states.map((val, i) => {

                        return (
                          <option value={val.id}>{val.name}</option>
                        )
                      })
                    }
                  </select></div>
                <div className='form-group col-lg-3 no-padding'>
                  <label className=' control-label'>
                    City</label>
                  <input type="text" placeholder='City'  value={city} onChange={(e) => setCity(e.target.value)} className='client-input' /></div>
                <div className='form-group col-lg-3 no-padding'>
                  <label className='control-label'>Postal Code</label>
                  <input type="text" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} className='client-input' placeholder='Enter postal code' />
                </div>
              </div>
            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="button" className='btn btn-primary_d' onClick={handleGoBack}>Go Back</button>
                </div>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="submit" className='btn btn-primary_d' onClick={createProfile}>Create
                    {
                      Loader &&
                      <div id="loader"></div>
                    }
                  </button>
                </div>
              </div>
            </div>

          </div>

        </div>
      <Modal isOpen={fillallfieldmodal} toggle={fillallfieldtoggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={fillallfieldtoggleModal}><span className="ml-1 roititle font-weight-bold">Error</span></ModalHeader>
        <ModalBody>
          <div className="modal-error-p">
            <p>Please fill all required field</p>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={emailalreadyExitmodal} toggle={EmailalreadyExittoggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={EmailalreadyExittoggleModal}><span className="ml-1 roititle font-weight-bold">Error</span></ModalHeader>
        <ModalBody>
          <div className="modal-error-p">
            <p>Distributor already exist with this email</p>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Successfull</span></ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="right-circle"><img src={right} /></div>
            <h4>Saved!</h4>
            <p>Tech Support Profile has been created successfully</p>
          </div>
        </ModalBody>

      </Modal>
    </PageLayout>
  );
};

export default TechSupport;
